import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

export const GamstopPreviouslyPositiveRestrictionPeriodPanelWrapper = styled('div', { label: 'GamstopPreviouslyPositiveRestrictionPeriodPanelWrapper' })`
    margin: -4px 0 0 28px;
    padding: 12px 16px;
    border: 1px solid ${mainColors.grays.gray200};
    border-radius: 8px;
    background-color: ${mainColors.grays.gray100};
`;

export const GamstopPreviouslyPositiveRestrictionPeriodField = styled('div', { label: 'GamstopPreviouslyPositiveRestrictionPeriodField' })`
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-width: 280px;

    > div {
        margin-bottom: 0;
    }
`;

export const GamstopPreviouslyPositiveRestrictionPeriodFieldLabel = styled('span', { label: 'GamstopPreviouslyPositiveRestrictionPeriodFieldLabel' })`
    font-size: 12px;
    font-weight: 500;
    line-height: 1.33;
    color: ${mainColors.grays.gray400};
`;
